import { useAtomValue } from 'jotai';
import { ChangeEventHandler, useCallback, useState } from 'react';
import { FieldValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Checkbox, Text } from '@/lib/v2/components';

import { atomTouchRules } from '@/src/modules/RulesModule/atoms/rules';

import { atomActionData } from '@/modules/CampaignsModule/atoms/campaignAtom';
import { TRANSLATE_RULES_LABELS } from '@/modules/RulesModule/constants';
import { IFormProps } from '@/modules/RulesModule/interfaces';

interface ITouchRulesCheckboxProps<T extends FieldValues> {
  form: IFormProps<T>;
  disabled?: boolean;
}
export const TouchRulesCheckbox = <T extends FieldValues>({
  form,
  disabled = false,
}: ITouchRulesCheckboxProps<T>) => {
  const { t } = useTranslation('rules');

  const actionData = useAtomValue(atomActionData);
  const touchRulesCheck = useAtomValue(atomTouchRules);

  const [touchRules, setTouchRules] = useState(touchRulesCheck ?? actionData?.touchRules);

  const onCheckedChange: ChangeEventHandler<HTMLInputElement> = useCallback((e) => {
    setTouchRules(e.target.checked);
  }, []);

  return (
    <div className="mt-8 flex">
      <Checkbox
        checked={touchRules}
        control={form.control}
        disabled={disabled}
        id="touchRules"
        label={
          <Text variant="text">
            {t(`${TRANSLATE_RULES_LABELS}.subordinate`)}{' '}
            <strong>{t(`${TRANSLATE_RULES_LABELS}.touchRule`)}</strong>
          </Text>
        }
        name="touchRules"
        onChange={onCheckedChange}
      />
    </div>
  );
};
